import { render, staticRenderFns } from "./EmployeeAuth.vue?vue&type=template&id=6472c002&"
import script from "./EmployeeAuth.vue?vue&type=script&lang=js&"
export * from "./EmployeeAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports